import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardActions, CardContent, CardMedia, Typography, } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore, } from '@mcn-platform/models';
import AssetImage from '../../common/asset/AssetImage';
// import Badge from './Badge';
// import CourseRating from './CourseRating';
import ItemInstructors from './ItemInstructors';
import ItemHeadline from './ItemHeadline';
import ItemPrice from './ItemPrice';
import { configureSalesCard } from '../../common/portalConfig';
import ItemInfo from './ItemInfo';
const ActionButton = ({ label, action }) => (_jsx(Button, { sx: {
        fontSize: '12 !important',
        // fontWeight: '600 !important',
        paddingRight: '10px !important',
        color: 'primary.main !important',
    }, size: "small", onClick: action, children: label }));
const HorizontalMediaCard = ({ item, size = 'large', showPrice, viewAction, registerAction, }) => {
    const { currentPortal, getItemProgress } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    if (!(item && currentPortal)) {
        return null;
    }
    // item can be either an item in a category (that contains a course or program)
    // or simply the course or item directly.
    const targetItem = item.course || item.program || item.microcast || item;
    const { name, headline, description, price, sellPrice,
    /* avgRating, reviews, */
     } = targetItem;
    const itemProgress = getItemProgress(targetItem);
    const { instructorAction, } = configureSalesCard(currentPortal, targetItem, itemProgress, navigate, location, '.');
    return (_jsxs(Card, { sx: {
            maxWidth: '100%',
            width: '100%',
            boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px !important',
            display: 'flex', // make sure vertical should be flex too.
            flexDirection: 'row',
        }, children: [_jsx(CardMedia, { children: _jsx(AssetImage, { asset: targetItem?.itemImage(), customStyle: { width: '100%', height: '200px', objectFit: 'cover' }, 
                    // showFallbackOnError
                    size: "thumb400w" }) }), _jsxs("div", { style: { width: '100%', flex: 0.97 }, children: [_jsxs(CardContent, { sx: { width: (size === 'medium') ? '100%' : '', paddingTop: (size === 'medium') ? '0 !important' : '' }, children: [_jsx("div", { style: {
                                    display: 'flex', flexDirection: 'row', justifyContent: 'space-between', minHeight: '3em',
                                }, children: _jsx(Typography, { variant: "subtitle1", component: "div", sx: { display: '-webkit-box', '-webkit-box-orient': 'vertical', overflow: 'hidden' }, children: name }) }), showPrice && (_jsx("div", { children: _jsx(ItemPrice, { price: price, sellPrice: sellPrice }) })), _jsx("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }, children: _jsx(ItemInfo, { item: targetItem }) }), _jsx(ItemHeadline, { showTitle: false, headline: headline, description: description, size: size }), _jsx(ItemInstructors, { size: size, instructors: targetItem?.instructors, showAvatar: true, instructorAction: instructorAction })] }), _jsx(CardActions, { sx: {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingTop: size === 'medium' ? '0 !important' : '',
                            paddingBottom: size === 'medium' ? '0 !important' : '',
                        }, children: _jsxs("div", { children: [viewAction && (_jsx(ActionButton, { label: "Learn More", action: () => viewAction(targetItem) })), registerAction && (_jsx(ActionButton, { label: "Register", action: () => registerAction(targetItem) }))] }) })] })] }));
};
HorizontalMediaCard.defaultProps = {
    viewAction: undefined,
    registerAction: undefined,
};
export default HorizontalMediaCard;
//# sourceMappingURL=HorizontalMediaCard.js.map